import { Type } from '@angular/core';
import { FormArray } from '@angular/forms';

export type ComponentCell<C = any> = {
  component: Type<C>;
  data: Partial<C>;
  formControl?: boolean;
  formArray?: FormArray;
};

export interface Column {
  id: string;
  name: string;
  type?: ColumnType;
  markable?: boolean;
  columnConfig?: StatusColumTypes;
  mask?: string;
  component?: ComponentCell;
}

export enum ColumnType {
  STATUS = 'STATUS',
  CURRENCY = 'CURRENCY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  MASK = 'MASK',
  NAME = 'NAME',
  SELECT_DATA = 'SELECT_DATA',
  CPF_CNPJ = 'CPF_CNPJ',
  COMPONENT = 'COMPONENT',
}

export enum Cores {
  REPROVADO = 'red',
  APROVADO = 'green',
  AGUARDANDO = 'orange',
  DEFAULT = 'gray',
}

export interface StatusColumTypes {
  [name: string]: StatusColum;
}
export interface StatusColum {
  color: string;
  description: string;
  icon?: string;
}

export interface SelectedItem {
  id: any;
  page?: number;
}
